import { IMenuItem } from '../services/navigation.service';

export const PORTAL_DEFAULT_MENU: IMenuItem[] = [
	{
		id: 1,
		name: 'Dashboard',
		description: '',
		type: 'dropDown',
		icon: 'i-Bar-Chart',
		sub: [
			{
				id: 11,
				icon: 'i-Bar-Chart-3',
				name: 'Mi Dashboard',
				state: '/dashboard/administrador',
				type: 'link',
			},
		],
	},
	{
		id: 2,
		name: 'Portal Clientes',
		description: '',
		type: 'dropDown',
		icon: 'i-Business-ManWoman',
		sub: [
			{
				id: 7,
				icon: 'i-Bar-Chart-3',
				name: 'Mi Dashboard',
				state: '/dashboard/cliente',
				type: 'link',
			},
			//{ id: 4, icon: 'i-Male', name: 'Mi Perfil', state: '/payment/profile', type: 'link' },
			{
				id: 6,
				icon: 'i-Book',
				name: 'Estado de Cuenta / Paga tu cuenta',
				state: '/payment/accounts-state',
				type: 'link',
			},
			{
				id: 5,
				icon: 'i-Shopping-Cart',
				name: 'Mis Compras',
				state: '/payment/shopping',
				type: 'link',
			},
		],
	},
	{
		id: 3,
		name: 'Administración',
		description: 'Portal',
		type: 'dropDown',
		icon: 'i-Management',
		sub: [
			//{ id: 11, icon: 'i-Male', name: 'Mi Perfil', state: '/pages/productos', type: 'link' },
			{
				id: 8,
				icon: 'i-Security-Check',
				name: 'Accesos Cliente',
				state: '/payment/send-access',
				type: 'link',
			},
			{
				id: 10,
				icon: 'i-Gear',
				name: 'Configuración Portal',
				state: '/payment/config',
				type: 'link',
			},
			{
				id: 9,
				icon: 'i-Mail-Send',
				name: 'Configuración Correos',
				state: '/pages/correos',
				type: 'link',
			},
			{
				id: 13,
				icon: 'i-Mail-Send',
				name: 'Pasarelas de pago',
				state: '/payment/payment-settings',
				type: 'link',
			},
			{
				id: 18,
				icon: 'i-Lock-User',
				name: 'Perfiles',
				state: '/security/profiles',
				type: 'link',
			},
			{
				id: 19,
				icon: 'i-Security-Check',
				name: 'Permisos',
				state: '/security/permissions',
				type: 'link',
			},
			{
				id: 20,
				icon: 'i-MaleFemale',
				name: 'Usuarios',
				state: '/security/users',
				type: 'link',
			},
		],
	},
	{
		id: 14,
		name: 'Cobranzas',
		description: '',
		type: 'dropDown',
		icon: 'i-Management',
		sub: [
			{
				id: 15,
				icon: 'i-Book',
				name: 'Asistidas',
				state: '/payment/collections',
				type: 'link',
			},
			{
				id: 17,
				icon: 'i-Book',
				name: 'Automatizadas',
				state: '/payment/automation',
				type: 'link',
			},
			{
				id: 16,
				icon: 'i-Book',
				name: 'Clientes Excluidos',
				state: '/payment/excluded',
				type: 'link',
			},
			// { id: 15, icon: 'i-Home1', name: 'Empresas', state: '/implementation/company', type: 'link' },
		],
	},
];

export const PORTAL_PAYMENT_MENU: IMenuItem[] = [
	{
		name: 'Portal de Pagos',
		description: '',
		type: 'dropDown',
		icon: 'i-Money-Bag',
		sub: [
			{
				icon: 'i-Home1',
				name: 'Inicio',
				state: '/payment/payment',
				type: 'link',
			},
			{
				icon: 'i-Male',
				name: 'Mi Perfil',
				state: '/payment/profile',
				type: 'link',
			},
			{
				icon: 'i-Book',
				name: 'Estado de Cuentas',
				state: '/payment/accounts-state',
				type: 'link',
			},
			{
				icon: 'i-Shopping-Cart',
				name: 'Compras',
				state: '/payment/shopping',
				type: 'link',
			},
			{
				icon: 'i-Mail-Send',
				name: 'Envío de Cobranza',
				state: '/payment/send-collections',
				type: 'link',
			},
			{
				icon: 'i-Gear',
				name: 'Configuración',
				state: '/payment/config',
				type: 'link',
			},
		],
	},
];

export const PORTAL_IMPLEMENTATION_MENU: IMenuItem[] = [
	{
		name: 'Implementación',
		description: '',
		type: 'dropDown',
		icon: 'i-Management',
		sub: [
			{
				id: 1,
				icon: 'i-File',
				name: 'Empresas',
				state: '/implementation/company',
				type: 'link',
			},
		],
	},
];
